module.exports = __webpack_public_path__ + "static/img/gold6.3d9e3640.webp";